import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import './Welcome.css'; // Custom animation styles

export default function Welcome() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/landing'); // Redirect to homepage after 3 seconds
    }, 3000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Box className="welcome-bg" sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', color: 'white' }}>
      <Box className="diamond-loader" />
      <Typography variant="h4" mt={4}>
        Fentrixbank
      </Typography>
      <Typography variant="subtitle2" mt={1}>
        Banking Beyond Borders
      </Typography>
    </Box>
  );
}
